module.exports = __webpack_public_path__ + "static/services-4-deaabeee8f06a6624a683b1cc9e877b7.jpg";